<script lang="ts" setup>
import { ref } from 'vue';
import { useLocale } from '../composables/useLocale';

const { t } = useLocale();

type Props = {
  text?: string;
};

const props = defineProps<Props>();
const showTooltip = ref<boolean>(false);

const copyText = async () => {
  if (props.text) {
    try {
      await navigator.clipboard.writeText(props.text);
    } catch {
      //
    }
    showTooltip.value = true;
    setTimeout(() => {
      showTooltip.value = false;
    }, 400);
  }
};
</script>
<template>
  <v-tooltip v-model="showTooltip" :text="t('lcp.copied')" :open-on-hover="false" :open-on-focus="false" location="top">
    <template v-slot:activator="{ props }">
      <span
        v-bind="props"
        class="pointer"
        tabindex="0"
        role="button"
        :aria-label="`${t('lcp.copy')} ${text}`"
        @click="copyText()"
        @keypress="(e) => (e.code === 'Enter' || e.code === 'Space') && copyText()"
      >
        {{ text }}</span
      >
    </template>
  </v-tooltip>
</template>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>
